import React from "react"
import Notification from 'rc-notification';
import 'rc-notification/assets/index.less';
import "./index.css"

let notificationInstance = null;

Notification.newInstance({}, n => {
    notificationInstance = n;
});

const ContentBox = (props) => {
    let {title, description} = props;
    return (
        <>
            <div className={'rc-notification-notice-message'}>{title}</div>
            {description ? <div className={'rc-notification-notice-description'}>{description}</div> : null}
        </>
    )
}
const getIcon = (type) => {
    if (type == 'success') {
        return <img src={'../images/correct.png'} className={`icon rc-notification-notice-icon-${type}`}/>
    } else if (type == 'warning') {
        return <img src={'../images/warning.png'} className={`icon rc-notification-notice-icon-${type}`}/>
    } else if (type == 'error') {
        return <img src={'../images/failed.png'} className={`icon rc-notification-notice-icon-${type}`}/>
    } else {
        return <img src={'../images/warning.png'} className={`icon rc-notification-notice-icon-${type}`}/>
    }
}
const ContentBoxWithIcon = (props) => {
    let {title, description, type} = props;
    return (
        <>
            <div>
                <div className={'rc-notification-notice-icon'}>
                    {getIcon(type)}
                </div>
                <div className={'rc-box'}>
                    <div className={'rc-notification-notice-message'}>{title}</div>
                    {description ? <div className={'rc-notification-notice-description'}>{description}</div> : null}
                </div>
            </div>
        </>
    )
}
const CloseIcon = () => {
    return (
        <span className={'rc-notification-close-icon'}>
           <svg viewBox="64 64 896 896" focusable="false" className="" data-icon="close" width="1em" height="1em"
                fill="currentColor" aria-hidden="true"><path
               d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg>
        </span>
    )
}

const duration = 3
const notification = {
    open: (props) => {
        notificationInstance.notice({
            content: <ContentBox {...props}/>,
            duration: props.duration || duration,
            closable: true,
            closeIcon: <CloseIcon/>
        });
    },
    success: (props) => {
        notificationInstance.notice({
            content: <ContentBoxWithIcon {...props} type={'success'}/>,
            duration: props.duration || duration,
            closable: true,
            closeIcon: <CloseIcon/>
        });
    },
    warning: (props) => {
        notificationInstance.notice({
            content: <ContentBoxWithIcon {...props} type={'warning'}/>,
            duration: props.duration || duration,
            closable: true,
            closeIcon: <CloseIcon/>
        });
    },
    error: (props) => {
        notificationInstance.notice({
            content: <ContentBoxWithIcon {...props} type={'error'}/>,
            duration: props.duration || duration,
            closable: true,
            closeIcon: <CloseIcon/>
        });
    },
    info: (props) => {
        notificationInstance.notice({
            content: <ContentBoxWithIcon {...props} type={'info'}/>,
            duration: props.duration || duration,
            closable: true,
            closeIcon: <CloseIcon/>
        });
    }
}

export default notification
